import React from 'react';
import LocationTemplate from './LocationTemplate';

const HavelockPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Havelock"
      stateName="North Carolina"
      countyName="Craven"
      zipCodes={["28532"]}
      latitude={34.8791}
      longitude={-76.9013}
      population={19467}
      historicalFact="Home to Marine Corps Air Station Cherry Point, the largest Marine Corps air station."
      nearbyTowns={[
        "New Bern, NC",
        "Morehead City, NC",
        "Newport, NC",
        "Beaufort, NC",
        "Oriental, NC",
        "Jacksonville, NC",
        "Emerald Isle, NC",
        "Atlantic Beach, NC"
      ]}
    />
  );
};

export default HavelockPage;